<template>
  <div class="parent-box">
    <div class="nav">
      <StatusView />
      <div class="navbox">
          <img class="left" src="@/assets/nav/yz_nav_fh.png" alt="" v-on:click="goBack()"/>
      </div>
    </div>
    <div class="content">
      <van-list
        v-model:loading="state.loading"
        :finished="state.finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
      <div class="item-container">
        <img class="top-bg1" src="@/assets/welfare/hyzl_bg1.png" alt="">
         <img class="top-bg2" src="@/assets/welfare/hyzl_bg2.png" alt="">
        <div class="cell-box">
          <van-cell
            v-for="(item, i) in state.getLists"
            :key="i + '-list'"
            :border="false"
            @click="goDetail(item)"
          >
            <template #value>

              <div class="game">
                <img class="pic" :src="item.pic1" alt="">
                <div class="info">
                  <p class="van-ellipsis">{{ item.gamename }}</p>

                  <div class="discount" v-if="item.firstpay > 0 && item.firstpay < 1">
                    {{ item.firstpay * 10 }}折
                  </div>
                </div>

                <img @click.stop="goActivity(item)" class="btn" src="@/assets/welfare/activity_btn.png" alt="">
                
              </div>

              <div class="content2 van-ellipsis">
                {{ item.welfare }}
              </div>
              <div class="time">
                活动结束时间：{{ timestampToTime(item.endtime)}}
              </div>

            </template>
          </van-cell>
        </div>
      </div>
        

      </van-list>
    </div>
  </div>
</template>
<script>
import { useRouter } from "vue-router";
import { reactive, onMounted, computed, onActivated } from "vue";
import { useStore } from "vuex";
import { Toast } from "vant";
import { setToken, getToken, removeToken } from "@/utils/auth";
import { getQueryString } from "@/utils/location";
import { hyzllist } from "../../api/boxpage";
import { timestampToTime } from "../../utils/date";
import StatusView from "../public/StatusView.vue";
import {
  detect,
} from '@/utils/device';
export default {
  name: "get_record",
  components: {
    StatusView,
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      getLists: [],
      loading: false,
      finished: false,
      topImg: "",
    });
    onActivated(() => {
      if (getQueryString("token")) {
        setToken(getQueryString("token"));
      }
      // onLoad();
    });


    var pagecode = 1;
    var totalpage = 1;
    const onLoad = () => {
      hyzllist({
        username: getQueryString("username"),
        pagecode: pagecode,
      }).then((res) => {
        console.log("赠送余额领取记录", res.data.data);
        if (pagecode == 1) {
          state.getLists = [];
        }
        if (res.data.code == 1) {
          totalpage = res.data.data.total_page;

          state.getLists = state.getLists.concat(res.data.data.lists);
          if(res.data.data.lists.length > 0){
            state.topImg = res.data.data.lists[0].pic4;
          }
          

          if (pagecode >= res.data.data.total_page) {
            state.finished = true;
            return;
          }
        } else {
          Toast(res.data.msg);
          state.finished = true;
        }
        // console.log(pagecode)
        pagecode++;
        state.loading = false;
        // console.log("赠送余额领取记录----------", state.getLists);
      });
    };

    const goDetail = (item)=>{
      if (detect() == "android" || detect() == "harmony") {
        window.document.location = "gogame://" + item.gid;
      } else {
        var eventData = {
          eventType: "openEvent",
          gid: item.gid,
        };
        window.parent.postMessage(eventData, "*");
      }
    }

    const goActivity = (item) => {
        
        if (detect() == "android" || detect() == "harmony") {
          window.JsBridge.skipAppWebActivity(item.url, item.gamename);
        } else {
          var eventData = {
            eventType: "skipAppWebActivity",
            url: item.url,
            title: item.gamename,
          };
          window.parent.postMessage(eventData, "*");
        }
    }

    const goBack = () => {
        if (detect() == "android" || detect() == "harmony") {
          window.document.location = "goBack://";
        } else {
          router.go(-1);
        }
    }
    return {
      state,
      onLoad,
      goDetail,
      goActivity,
      timestampToTime,
      goBack
    };
  },
};
</script>
<style scoped="scoped" src="@/styles/van-sticky-nav.css"></style>
<style>
body {
  background: #F2F4FF;
}
</style>
<style scoped="scoped">
.nav {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
}

.navbox {
  position: relative;
  height: 90px;
  width: 100%;
}

.navbox .left {
  width: 70px;
  height: 70px;
  padding: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 22px;
}


.top-bg {
  width: 100%;
}

.content {
  box-sizing: border-box;
}

.parent-box {
  height: 100vh;
  overflow: auto;
  background-color: #F2F4FF;
}

.item-container {
  position: relative;
}

.top-bg1 {
  width: 100%;
  position: absolute;
  top: 0;
}


.top-bg2 {
  width: 100%;
  position: absolute;
  top: 440px;
}


.cell-box {
  padding-left: 32px;
  padding-right: 32px;
  position: absolute;
  top: 610px;
  width: 100%;
}
.van-cell {
  background: #fff;
  display: block;
  border-radius: 24px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0px 4px #83C0FF;
}
.van-cell p {
  color: #333;
}
.van-cell p:nth-of-type(1) {
  font-size: 32px;
  color: #333;
  font-weight: bold;
  /* margin-bottom: 12px; */
}
.van-cell p:nth-of-type(2) {
  /* margin-top: 12px; */
  font-size: 24px;
}


.game {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.game .pic {
  width: 128px;
  height: 128px;
  border-radius: 24px;
}
.game .info {
  margin-left: 24px;
  margin-right: 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;

}

.discount {
  font-size: 24px;
  height: 32px;
  line-height: 32px;
  padding: 0 8px;
  font-family: 'bbt';
  color: white;
  border-radius: 12px;
  align-self: flex-start;
  margin-top: 12px;
  border: 2px solid #0000001a;
  background: radial-gradient(62.3% 121.82% at 50% 100%, #fed4ce 0%, #fed4ce00 100%), #fa533d;
}

.game .btn {
  width: 136px;
  height: 56px;
  
}

.content2 {
  font-size: 28px;
  line-height: 32px;
  color: #333333;
  margin-top: 20px;
}
.time {
  font-size: 24px;
  line-height: 24px;
  margin-top: 16px;
  color: #666666;
}
</style>
